module.exports = __webpack_public_path__ + "themes/mf/font/proximasoft-bold-webfont.woff";


//////////////////
// WEBPACK FOOTER
// ./themes/mf/font/proximasoft-bold-webfont.woff
// module id = 140
// module chunks = 3